<template>
  <div class="flex justify-center">
    <div class="relative">
      <img class="defWidth" src="@/assets/images/map/basemap.png" alt="" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.defWidth {
  min-width: 1440px;
  max-width: 1440px;
  min-height: 1084px;
  max-height: 1084px;
}
</style>